import { Button } from "primereact/button";
import { FC, useState } from "react";
import { useResponsive } from "../../../../responsive/ResponsiveProvider";
import { BannerSection } from "../../../../models/manageWebSite";
import EditModal from "./EditModal";

interface Section2Props {
  data: BannerSection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
}

const Section2: FC<Section2Props> = ({ data, flag, setFlag, homeId }) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const mobile = useResponsive().isMobile;

  return (
    <div
      style={{
        width: "100%",
        padding: mobile ? "1.5rem 1rem 2rem" : "2rem 1.5rem 3rem",
        background: `linear-gradient(180deg, rgba(255,247,237,0.55) 0%, rgba(248,251,255,0.82) 100%), url(${data?.backgroundSignedImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        style={{
          maxWidth: "1180px",
          margin: "0 auto",
          background: "rgba(255,255,255,0.88)",
          border: "1px solid rgba(217,232,245,0.9)",
          borderRadius: "32px",
          padding: mobile ? "1.25rem" : "1.5rem",
          boxShadow: "0 26px 50px rgba(15,61,99,0.12)",
          backdropFilter: "blur(10px)",
        }}
      >
        <div className="grid align-items-center">
          <div className="col-12 lg:col-6">
            <div style={{ color: "#9a3412", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem" }}>
              Welcome families with confidence
            </div>
            <div style={{ color: "#0f172a", fontSize: mobile ? "1.55rem" : "2.3rem", lineHeight: 1.25, fontWeight: 800, marginTop: "0.9rem", whiteSpace: "pre-line" }}>
              {data?.description}
            </div>
            <div className="mt-4">
              <Button severity="warning" label="Edit Banner" onClick={() => setOpenModal(true)} className="website-section-action-button" />
            </div>
          </div>
          <div className="col-12 lg:col-6 flex justify-content-center">
            <img
              src={data?.sectionSignedImg}
              style={{
                objectFit: "cover",
                width: "100%",
                maxWidth: mobile ? "100%" : "520px",
                height: mobile ? "260px" : "420px",
                borderRadius: "26px",
                boxShadow: "0 22px 44px rgba(15,61,99,0.14)",
              }}
              className="m-2"
            />
          </div>
        </div>
      </div>
      <EditModal
        isOpen={openModal}
        toggleModal={setOpenModal}
        flag={flag}
        setFlag={setFlag}
        data={data}
        homeId={homeId}
      />
    </div>
  );
};

export default Section2;
